// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3XhWP","title":"Header_title__3pn5U","side":"Header_side__35GTL"};